export default __webpack_public_path__ + "static/media/paragraph.b00eb61a.png";